"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDocumentOutline = void 0;
const slate_1 = require("slate");
const HEADING_LEVELS = {
    title: 0,
    h1: 1,
    h2: 2,
    h3: 3,
    h4: 4,
    h5: 5,
    h6: 6,
};
const isOutlineHeadingType = (type) => type === 'h1' ||
    type === 'h2' ||
    type === 'h3' ||
    type === 'h4' ||
    type === 'h5' ||
    type === 'h6' ||
    type === 'title';
const collectDocumentOutline = (nodes, path, outline) => {
    nodes.forEach((node, index) => {
        if (slate_1.Text.isText(node))
            return;
        const nodePath = [...path, index];
        if (slate_1.Element.isElement(node) && isOutlineHeadingType(node.type)) {
            const title = slate_1.Node.string(node).trim();
            if (title) {
                outline.push({
                    key: nodePath.join('.'),
                    path: nodePath,
                    type: node.type,
                    level: HEADING_LEVELS[node.type],
                    title,
                });
            }
        }
        collectDocumentOutline(node.children, nodePath, outline);
    });
};
const getDocumentOutline = (value) => {
    const outline = [];
    collectDocumentOutline(value, [], outline);
    return outline;
};
exports.getDocumentOutline = getDocumentOutline;
